// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__HetwK","colMaxWidth":"Table_colMaxWidth__16Ww7"};